import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { RefactoredChartContainer } from '../../../charts/d3/candlestickchart/newCandleChart/chartContainer/RefactoredChartContainer';
import AlertChartHeader from '../../../charts/d3/candlestickchart/newCandleChart/chartHeader/AlertChartHeader';

export const AlertChartWrapper = observer(
  ({
    symbol,
    timeUnit,
    candleDuration,
    numberOfCandles,
    setters,
    showCandleNumbers,
    width,
    height,
    dataSource
  }) => {
    let size = 230;
    if (width && height) {
      if (width + 1 > height) {
        size = height * 87;
      } else {
        size = width * 112;
      }
    }
    const brokerage = 'TRADIER';
    const tradePlanId = 'none';
    const type = 'alert';
    const startHour = 9;
    const startMin = 30;
    return (
      <div>
        <AlertChartHeader
          type={type}
          setters={setters}
          symbol={symbol}
          showCandleNumbers={showCandleNumbers}
          dataSource={dataSource}
          brokerage={brokerage}
          numberOfCandles={numberOfCandles}
          timeUnit={timeUnit}
          candleDuration={candleDuration}
        />
        <RefactoredChartContainer
          tradePlanId={tradePlanId}
          symbol={symbol}
          dataSource={dataSource}
          brokerage={brokerage}
          numberOfCandles={numberOfCandles}
          timeUnit={timeUnit}
          candleDuration={candleDuration}
          id={1}
          size={size}
          margin={4}
          padding={30}
          showCandleNumbers={showCandleNumbers}
          startHour={startHour}
          startMin={startMin}
          setNumberOfCandles={setters.setNumberOfCandles}
        />
      </div>
    );
  }
);

AlertChartWrapper.propTypes = {
  candleDuration: PropTypes.any,
  numberOfCandles: PropTypes.any,
  setters: PropTypes.any,
  showCandleNumbers: PropTypes.any,
  symbol: PropTypes.any,
  timeUnit: PropTypes.any,
  width: PropTypes.number,
  height: PropTypes.number,
};
